export const openMenu = () => ({ type: 'OPEN_MENU' });

export const closeMenu = () => ({ type: 'CLOSE_MENU' });

export const setActiveTab = active => ({
  type: 'SET_ACTIVE_TAB',
  payload: active,
});
